export default "__VITE_ASSET__Da_h$d5m__"